import { ref } from '@vue/composition-api'
import useCheckout from "../composables/useCheckout"

let sessionTimerId;
let showSessionExpireModal;

export default function useSessionKeeper () {
    if (sessionTimerId == undefined) {
        sessionTimerId = ref("");
    }

    if (showSessionExpireModal == undefined) {
        showSessionExpireModal = ref(false);
    }

    const { info: checkoutinfo } = useCheckout();
    const sessionLength = 30*(60*1000); //30 minutes - in milliseconds

    const start = () => {
		cancel();
		sessionTimerId.value = setTimeout(() => {
			expire();
		}, sessionLength)
	}

    const cancel = () => {
        clearTimeout(sessionTimerId.value);
    }

	const expire = () => {
        showSessionExpireModal.value = true;
	}

    const closeSessionExpireModal = () => {
        showSessionExpireModal.value = false;

        if (checkoutinfo.value.isQuote) {
            //redirects back to quote
            window.location.href = '/quote?q=' + checkoutinfo.value.quoteHash;
        } else {
            //refresh the page, which will take a user back to the cart and update the coldfusion session
            location.reload();
        }

    }

    return {
        startSession: start,
        cancelSessionTimer: cancel,
        showSessionExpireModal,
        closeSessionExpireModal
    }
}
